import { useState } from 'react';

import { useSelector } from 'react-redux';
import { usePermission } from '../../../../hooks/usePermission';
import { accountSelector, authSelector } from '../../../../store';
import { navItemObjects, sageAdminNavItemObjects } from '../../NavConstant';
import SidebarNavHeader from '../../SibarNavHeader';
import SidebarNavFooter from '../../SidebarNavFooter';
import NavItem from '../NavItem';

export default function BigScreenNav() {
  const { data: accountInfo } = useSelector(accountSelector);
  const { data: currentUserData } = useSelector(authSelector);
  const [isFullNavHidden, setIsFullNavHidden] = useState(false);
  const navItems = currentUserData.account === 'sageadmin' ? sageAdminNavItemObjects : navItemObjects;

  const navToggleHandler = () => {
    setIsFullNavHidden((prevState) => !prevState);
  };
  const { hasPermission } = usePermission();
  return (
    <div
      className={`hidden flex flex-col ${
        isFullNavHidden ? 'w-20' : 'w-80'
      } lg:flex lg:shrink-0 min-h-0 border-r border-gray-200 transition transition-width duration-200 ease-in-out`}
    >
      <div className='flex-1 flex flex-col pt-5 pb-4 overflow-y-auto'>
        <SidebarNavHeader isFullNavHidden={isFullNavHidden} navToggleHandler={navToggleHandler} />
        <nav className='mt-5 flex-1 w-full' aria-label='Sidebar'>
          <div className='px-2 space-y-1'>
            {navItems.map((item) => {
              const { permissions, name, subscription } = item;
              if (hasPermission(permissions)) {
                if (subscription && !accountInfo?.subscriptions.includes(subscription)) {
                  return null;
                }
                return (
                  <NavItem
                    key={name}
                    item={currentUserData.account === 'birminghamhousing' && item.path === 'company' ? { ...item, path: 'company' } : item}
                    isFullNavHidden={isFullNavHidden}
                  />
                );
              }
              return null;
            })}
          </div>
        </nav>
        <SidebarNavFooter setIsFullNavHidden={navToggleHandler} isFullNavHidden={isFullNavHidden} />
      </div>
    </div>
  );
}
